module.exports = require("./bs-Latn.js");